import React from "react";
import { VsiH4 } from "../../../styled/App.styled";
import { useTitleFromComponent } from "../../../utils/hooks";

import { storageItems } from "../../../utils/routes";
import NavCard from "../../../components/NavCard";

// These screens are solely for the mobile version of our web app

export default function Storage({ title }) {
  useTitleFromComponent(title);
  return (
    <div>
      <VsiH4>Storage</VsiH4>
      {storageItems.map((item, index) => {
        return (
          <NavCard
            {...item}
            key={`nav-card-${item.title
              .toLowerCase()
              .split(" ")
              .join("-")}-${index}`}
          />
        );
      })}
    </div>
  );
}
